import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NewUserModal from './NewUserModal';

const NewUser: React.FC = () => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button variant="contained" onClick={handleOpen}>
        {t('users.newUser')}
      </Button>
      {open && <NewUserModal handleClose={handleClose} />}
    </>
  );
};

export default NewUser;
